import {User} from "./user";
import {PremiumAccount} from "./premium-account";

export class Business {

  public id:number;
  public name:string;
  public description:string;
  public street:string;
  public zipCode:string;
  public city:string;
  public country:string;
  public taxNumber:string;
  public websiteUrl:string;
  public email:string;
  public association:boolean;

  public publicProfile:boolean;

  public admins:User[] = [];

  public logoPath:string;
  public bannerPath:string;

  premium:PremiumAccount;
  activated:boolean = false;
  emailActivated:boolean = false;

  constructor() {

  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/model/business.ts